import { render } from "./TeethRadarChart.vue?vue&type=template&id=b64e5a4e&ts=true"
import script from "./TeethRadarChart.vue?vue&type=script&lang=ts"
export * from "./TeethRadarChart.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Dmes\\webdds-src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__